import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { DropdownModule } from 'primeng/dropdown';
import { TimelineModule } from 'primeng/timeline';
import { TooltipModule } from 'primeng/tooltip';
import { InputTextModule } from 'primeng/inputtext';
import { PanelModule } from 'primeng/panel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ToolbarModule } from 'primeng/toolbar';
import { SubscriptionsModule } from '../subscriptions/subscriptions.module';
import { GallerysRoutingModule } from './galleries.routes';
import { GalleryConsignmentProductsComponent } from 'src/app/components/gallery-components/gallery-consignment-products/gallery-consignment-products.component';
import { GalleryRequestedProductComponent } from 'src/app/components/gallery-components/gallery-requested-product/gallery-requested-product.component';
import { ProductSoldComponent } from 'src/app/common/productsold/productsold.component';
import { BaseModule } from 'src/app/models/base/base.module';
import { GalleryProductComponent } from 'src/app/components/gallery-components/gallery-product/gallery-product.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { FileUploadModule } from 'primeng/fileupload';
import { GalleryProductService } from 'src/app/Services/Gallery-Products-Service/galleryproduct.service';
import { ViewGalleryProductComponent } from 'src/app/components/gallery-components/view-gallery-products/view-gallery-product.component';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { InputSwitchModule } from 'primeng/inputswitch';
import { PlatformCurrencySettingsDialogComponent } from 'src/app/components/gallery-components/consignment-product-selection/platforms-currency-settings-dialogs/platform-currency-settings-dialog.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ShopifyAndWooCommerceDailog } from 'src/app/components/gallery-components/shopify-and-woocommerce-dailog/shopify-and-woocomerce-dailog.component';
import { TranslocoModule } from '@jsverse/transloco';
import { DsSharedModule } from 'src/app/common/ds-shared.module';

@NgModule({
  declarations: [
     GalleryConsignmentProductsComponent, GalleryRequestedProductComponent, ProductSoldComponent,
    ViewGalleryProductComponent,PlatformCurrencySettingsDialogComponent,ShopifyAndWooCommerceDailog
  ],
  //<p-autocomplete
  imports: [CommonModule, FormsModule, ReactiveFormsModule, GallerysRoutingModule, DialogModule, TableModule, OverlayPanelModule,BaseModule,
    TableModule, ToolbarModule, ButtonModule, InputTextModule, PanelModule, DialogModule, CheckboxModule,TimelineModule,BreadcrumbModule,
    RadioButtonModule, DropdownModule, RouterModule, PanelModule, TooltipModule,ImageCropperModule, FileUploadModule,InputSwitchModule,ProgressSpinnerModule,
    SubscriptionsModule.forRoot(), TranslocoModule, DsSharedModule,
  ],
  exports: [
    ProductSoldComponent,ShopifyAndWooCommerceDailog
  ],
  providers: [
    GalleryProductService
  ],
})
export class GallerysModule {
  static forRoot(): ModuleWithProviders<GallerysModule> {
    return {
      ngModule: GallerysModule
    };
  }
}
